import { Typography } from "@material-ui/core";
import React, { CSSProperties, ElementType } from "react";

interface RxTypographyProps {
	style?: CSSProperties;
	align?: "center" | "inherit" | "justify" | "left" | "right";
	variant?:
		| "body1"
		| "body2"
		| "button"
		| "caption"
		| "h1"
		| "h2"
		| "h3"
		| "h4"
		| "h5"
		| "h6"
		| "inherit"
		| "overline"
		| "subtitle1"
		| "subtitle2";
	gutterBottom?: false | true;
	noWrap?: false | true;
	paragraph?: false;
	label?: string | React.ReactNode;
	className?: string;
	color?:
		| "error"
		| "inherit"
		| "initial"
		| "primary"
		| "secondary"
		| "textPrimary"
		| "textSecondary";
	component?: ElementType<any>;
	onClick?: () => void;
}

const RxTypography = (props: RxTypographyProps) => {
	return (
		<Typography
			className={props.className}
			variant={props.variant}
			align={props.align}
			gutterBottom={props.gutterBottom}
			noWrap={props.noWrap}
			paragraph={props.paragraph}
			color={props.color}
			component={props.component ? props.component : "div"}
			style={props.style}
			onClick={props.onClick}
		>
			{props.label}
		</Typography>
	);
};
export default RxTypography;
